import { forwardRef, HTMLAttributes } from "react";

// An unstyled component that automatically switches between `<a>` and
// `<button>` based on the presence of a `href` and automatically applies some
// nice attribute defaults.`.

export interface ClickableProps extends HTMLAttributes<
  HTMLAnchorElement & HTMLButtonElement
> {
  href?: string;
  disabled?: boolean;
  target?: string;
}

const Clickable = forwardRef<
  HTMLAnchorElement & HTMLButtonElement,
  ClickableProps
>(({ href, disabled, ...restProps }, ref) => {
  return href != null ? (
    disabled ? (
      // Support `disabled` on links by removing the `href`. Also override
      // `onClick` to match `<button disabled>`.
      <a
        ref={ref}
        {...restProps}
        aria-disabled={disabled}
        onClick={() => {
          /*nothing*/
        }}
      />
    ) : (
      <a ref={ref} href={href} {...restProps} />
    )
  ) : (
    <button
      ref={ref}
      // `type` can be overridden via `restProps`.
      type="button"
      aria-disabled={disabled}
      disabled={disabled}
      {...restProps}
    />
  );
});

Clickable.displayName = "Clickable";

export default Clickable;
